var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3334 22.6181V26.6181C29.3349 26.9894 29.2589 27.357 29.1101 27.6972C28.9613 28.0374 28.7431 28.3429 28.4695 28.5939C28.1959 28.8449 27.8728 29.036 27.5211 29.155C27.1693 29.274 26.7966 29.3182 26.4267 29.2847C22.3239 28.8389 18.3827 27.4369 14.9201 25.1914C11.6985 23.1443 8.96719 20.413 6.92007 17.1914C4.66671 13.713 3.2644 9.75273 2.82674 5.63141C2.79342 5.26269 2.83724 4.89109 2.95541 4.54024C3.07357 4.18939 3.2635 3.86699 3.51309 3.59357C3.76269 3.32014 4.06648 3.10168 4.40513 2.9521C4.74378 2.80252 5.10986 2.72509 5.48007 2.72474H9.48007C10.1271 2.71837 10.7545 2.94751 11.2451 3.36945C11.7357 3.79139 12.0562 4.37733 12.1467 5.01807C12.3156 6.29816 12.6287 7.55504 13.0801 8.76474C13.2595 9.24197 13.2983 9.76062 13.1919 10.2592C13.0856 10.7579 12.8386 11.2156 12.4801 11.5781L10.7867 13.2714C12.6848 16.6095 15.4487 19.3733 18.7867 21.2714L20.4801 19.5781C20.8426 19.2196 21.3003 18.9725 21.7989 18.8662C22.2975 18.7599 22.8162 18.7987 23.2934 18.9781C24.5031 19.4295 25.76 19.7426 27.0401 19.9114C27.6878 20.0028 28.2793 20.329 28.7021 20.8281C29.125 21.3271 29.3496 21.9642 29.3334 22.6181Z",
    stroke: "#1E0D12",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1406d125e57a3b23e74080e15f5e84e9.svg";
export { ForwardRef as ReactComponent };